import { Option, Select, useToast } from '@workramp/ui';
import { useEffect } from 'react';
import { APP_CONSTANTS, I18n } from '~/common/explicit-exports';
import { hideLoader, MixPanel, setCookie, showLoader } from '~/common';
import { useGetUserSettingsQuery, useUpdateUserMutation } from '~/elc/features/learner/api';
import { ErrorPage } from '~/features/common';
import { LanguageWrapper } from '~/elc/features/learner/components/LearnerLanguage/LearnerLanguage.styles';

export function LearnerLanguage() {
  const { open: openToast } = useToast();
  const settingsQuery = useGetUserSettingsQuery();
  const updateUser = useUpdateUserMutation().mutateAsync;

  const SETTINGS = I18n.t('js.learner.profile.settings');
  const SETTINGS_UPDATED = I18n.t('js.learner.profile.toast_messages', { attribute: SETTINGS });
  const TRANSLATED_LANGUAGE = I18n.t('js.learner.profile.form.language');

  useEffect(() => {
    if (settingsQuery.isLoading) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [settingsQuery.isLoading]);

  if (settingsQuery.error) return <ErrorPage status={settingsQuery.error.status} />;

  if (!settingsQuery.data) return null;

  const user = settingsQuery.data;
  const userLanguageCode = user.language || user.enterprise.language || APP_CONSTANTS.DEFAULT_LANGUAGE;

  const handleLanguageSelect = async (language: string | number) => {
    await updateUser(
      { language: language.toString(), id: user.id },
      { onSuccess: () => openToast({ children: SETTINGS_UPDATED }) },
    );

    MixPanel.track('learner_settings_update', { attribute: 'language_preference', language });
    setCookie(APP_CONSTANTS.USER_LANGUAGE_COOKIE, language, APP_CONSTANTS.USER_LANGUAGE_COOKIE_EXPIRES_IN);

    window.location.reload(); // translate the current page
  };

  return (
    <LanguageWrapper>
      <Select
        label={TRANSLATED_LANGUAGE}
        onSelectionChange={handleLanguageSelect}
        size="sm"
        title={TRANSLATED_LANGUAGE}
        defaultSelectedKey={userLanguageCode}
      >
        {Object.entries(APP_CONSTANTS.AVAILABLE_LANGUAGES).map(([languageCode, display]) => (
          <Option key={languageCode}>{display}</Option>
        ))}
      </Select>
    </LanguageWrapper>
  );
}
